module.exports = __webpack_public_path__ + "img/1.dd5d0e91.png";